import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBranchSaveContactsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientBranchSaveContactsParam } from 'api/types/params';

import { parseLegalClientBranchEntity } from './helpers';

export const useLegalClientBranchSaveContacts = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBranchSaveContactsMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientBranchSaveContacts
      ? parseLegalClientBranchEntity(data.legalClientBranchSaveContacts)
      : undefined,
    loading,
    error,
    saveContacts: useCallback(
      async (
        id: string,
        branchId: string,
        params: LegalClientBranchSaveContactsParam
      ) => {
        const res = await handle({
          variables: {
            id,
            branchId,
            input: params,
          },
        });
        return res?.data?.legalClientBranchSaveContacts
          ? parseLegalClientBranchEntity(res.data.legalClientBranchSaveContacts)
          : undefined;
      },
      [handle]
    ),
  };
};
